"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _vuex = require("vuex");
var _permission = require("@/utils/permission");
var _merUseCategory = _interopRequireDefault(require("@/components/merUseCategory"));
var _validate = require("@/utils/validate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'createCoupon',
  data: function data() {
    return {
      currentTab: '1',
      tabList: [{
        value: '1',
        title: '基础设置'
      }, {
        value: '2',
        title: '使用范围'
      }],
      loading: false,
      formValidate: {
        name: '',
        //优惠券名称
        category: 3,
        //适用范围
        money: 1,
        //面值
        minPrice: 0,
        //使用门槛
        receiveType: 1,
        //领取方式
        isTimeReceive: true,
        //领取时间类型
        receiveStartTime: '',
        //可领取开始时间
        receiveEndTime: '',
        //可领取结束时间
        isFixedTime: false,
        day: 1,
        //天数
        useStartTime: '',
        //可使用时间范围 开始时间
        useEndTime: '',
        //可使用时间范围 结束时间
        isLimited: true,
        //是否限量
        total: 1,
        //总数
        num: 1,
        //编辑优惠券发布数量
        isRepeated: false,
        //是否可重复领取
        linkedData: null,
        //关联数据
        status: false,
        validityTime: [],
        //使用有效期
        collectionTime: [] //领取时间
      },
      pickerOptionsForEditCoupon: {
        // 时间有效校验
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      ruleValidate: {
        name: [{
          required: true,
          message: '请输入优惠券名称'
        }],
        money: [{
          required: true,
          message: '请输入优惠券面值'
        }],
        minPrice: [{
          required: true,
          message: '请输入优惠券使用门槛'
        }],
        receiveType: [{
          required: true,
          message: '请选择领取方式'
        }],
        isTimeReceive: [{
          required: true,
          message: '请选择领取时间类型'
        }],
        day: [{
          required: true,
          message: '请输入天数'
        }],
        total: [{
          required: true,
          message: '请输入发布数量'
        }],
        isLimited: [{
          required: true,
          message: '请选择使用有效期'
        }],
        isRepeated: [{
          required: true,
          message: '请选择是否可重复领取'
        }],
        isFixedTime: [{
          required: true,
          message: '请选择使用有效期'
        }],
        validityTime: [{
          type: 'array',
          required: true,
          message: '请选择日期区间',
          fields: {
            0: {
              //type: 'tpye', //tpye类型试情况而定,所以如果返回的是date就改成date
              required: true,
              trigger: 'change',
              message: '请选择开始日期'
            },
            1: {
              //type: 'tpye',
              required: true,
              trigger: 'change',
              message: '请选择结束日期'
            }
          }
        }],
        collectionTime: [{
          type: 'array',
          required: true,
          message: '请选择日期区间',
          fields: {
            0: {
              //type: 'tpye', //tpye类型试情况而定,所以如果返回的是date就改成date
              required: true,
              trigger: 'change',
              message: '请选择开始日期'
            },
            1: {
              //type: 'tpye',
              required: true,
              trigger: 'change',
              message: '请选择结束日期'
            }
          }
        }]
      },
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'childList',
        expandTrigger: 'hover',
        checkStrictly: false,
        emitPath: false,
        multiple: false
      },
      listLoading: false,
      selectGoods: false,
      multipleSelection: [],
      tableData: {
        data: [],
        total: 0
      },
      proBrandList: '',
      merIds: [],
      ids: [],
      linkedData: null
    };
  },
  components: {
    merchantName: _merUseCategory.default
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['merPlatProductClassify', 'productBrand'])), {}, {
    isEdit: function isEdit() {
      return this.$route.params.id ? true : false;
    },
    isCopy: function isCopy() {
      return this.$route.params.copy ? true : false;
    }
  }),
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
  },
  mounted: function mounted() {
    this.setTagsViewTitle();
    if (!localStorage.getItem('merPlatProductClassify')) this.$store.dispatch('product/getAdminProductClassify');
    if (!localStorage.getItem('productBrand')) this.$store.dispatch('product/getMerProductBrand');
    if (this.isEdit) {
      this.getInfo();
    }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //设置标题
    setTagsViewTitle: function setTagsViewTitle() {
      if (this.$route.params.id && this.$route.params.id != 0) {
        var title = this.isEdit && !this.isCopy ? '编辑优惠券' : this.isCopy ? '复制优惠券' : '添加优惠券';
        var route = Object.assign({}, this.tempRoute, {
          title: "".concat(title, "-").concat(this.$route.params.id)
        });
        this.$store.dispatch('tagsView/updateVisitedView', route);
      }
    },
    // 具体日期
    onChangeValidityTime: function onChangeValidityTime(e) {
      this.formValidate.validityTime = e;
      this.formValidate.useStartTime = e ? e[0] : '';
      this.formValidate.useEndTime = e ? e[1] : '';
    },
    // 领取时间
    onChangeCollectionTime: function onChangeCollectionTime(e) {
      this.formValidate.collectionTime = e;
      this.formValidate.receiveStartTime = e ? e[0] : '';
      this.formValidate.receiveEndTime = e ? e[1] : '';
    },
    back: function back() {
      this.$router.push({
        path: '/marketing/PlatformCoupon/list'
      });
    },
    // 获取商户id
    getMerId: function getMerId(id) {
      this.merIds = id;
    },
    addGoods: function addGoods() {
      var _this = this;
      this.$modalGoodList(function (row) {
        _this.listLoading = false;
        _this.tableData.data = row;
      }, 'many', _this.tableData.data);
    },
    //行删除
    handleDelete: function handleDelete(index, row) {
      var _this2 = this;
      this.$modalSure('删除该商品吗？').then(function () {
        _this2.tableData.data.splice(index, 1);
      });
    },
    //批量删除
    batchDel: function batchDel() {
      var _this3 = this;
      this.$modalSure('批量删除该商品吗？').then(function () {
        var data = [];
        var _iterator = _createForOfIteratorHelper(_this3.tableData.data),
          _step;
        try {
          var _loop = function _loop() {
            var item1 = _step.value;
            var _index = _this3.multipleSelection.findIndex(function (c) {
              return c.id === item1.id;
            });
            if (_index === -1) {
              data.push(item1);
            }
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _this3.tableData.data = data;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectAll: function selectAll(data) {
      var id = data.map(function (i, index) {
        return i.spu_id;
      });
      this.ids = Array.from(new Set([].concat(_toConsumableArray(this.ids), _toConsumableArray(id))));
    },
    selectOne: function selectOne(data, row) {
      var id = data.map(function (i, index) {
        return i.spu_id;
      });
      var index = this.ids.findIndex(function (e) {
        return e == row.spu_id;
      });
      this.ids.splice(index, 1);
      this.ids = Array.from(new Set([].concat(_toConsumableArray(this.ids), _toConsumableArray(id))));
    },
    handleCommand: function handleCommand(command) {
      var _this4 = this;
      this.$message('click on item ' + command);
      this.selectAllPage = command === 'all';
      this.$nextTick(function () {
        _this4.$refs.tableList.toggleAllSelection();
      });
    },
    getInfo: function getInfo() {
      var _this5 = this;
      (0, _marketing.couponInfoApi)(this.$route.params.id).then(function (res) {
        _this5.formValidate = JSON.parse(JSON.stringify(res));
        if (_this5.formValidate.isTimeReceive) {
          _this5.$set(_this5.formValidate, 'collectionTime', [_this5.formValidate.receiveStartTime, _this5.formValidate.receiveEndTime]);
        }
        if (res.category == 6) {
          _this5.merIds = _this5.formValidate.linkedData.split(',');
        } else if (_this5.formValidate.category == 4) {
          _this5.linkedData = Number(_this5.formValidate.linkedData);
        } else if (_this5.formValidate.category == 2) {
          _this5.tableData.data = _this5.formValidate.productList;
        } else if (_this5.formValidate.category == 5) {
          _this5.proBrandList = Number(_this5.formValidate.linkedData);
        }
        if (_this5.formValidate.useStartTime && _this5.formValidate.useEndTime) {
          _this5.$set(_this5.formValidate, 'validityTime', [res.useStartTime, res.useEndTime]);
        }
        _this5.formValidate.num = 1;
      });
    },
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this6 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this6.currentTab = '2';
        } else {
          _this6.$message.warning('请完善基础设置信息');
        }
      });
    }),
    //保存
    save: function save() {
      var _this7 = this;
      switch (this.formValidate.category) {
        case 6:
          this.formValidate.linkedData = this.merIds.toString();
          break;
        case 2:
          if (!this.tableData.data.length) return this.$message.error('请选择至少一个商品');
          var data = [];
          this.tableData.data.map(function (item) {
            return data.push(item.id);
          });
          this.formValidate.linkedData = data.toString();
          break;
        case 4:
          this.formValidate.linkedData = this.linkedData;
          break;
        case 5:
          this.formValidate.linkedData = this.proBrandList.toString();
          break;
        default:
          this.formValidate.linkedData = '';
          break;
      }
      if (this.formValidate.receiveType === 3) this.formValidate.isTimeReceive = false;
      if (!this.formValidate.isLimited) {
        this.formValidate.total = 1;
      }
      if (this.isEdit && !this.isCopy) {
        (0, _marketing.platformCouponEditApi)(this.formValidate).then(function (res) {
          _this7.$message.success('添加成功');
          _this7.back();
        });
      } else {
        (0, _marketing.platformCouponAddApi)(this.formValidate).then(function (res) {
          _this7.$message.success('添加成功');
          _this7.back();
        });
      }
    }
  }
};